import AsyncStorage from '@react-native-async-storage/async-storage';

import { DIETARY_RESTRICTIONS_STORAGE_KEY } from '../../../constants';

import type { dietaryRestrictionsModel } from './dietaryRestrictionsMachine';
import type { ContextFrom } from 'xstate';

// ─── Utils ───────────────────────────────────────────────────────────────────

export async function getMachinePersistedState() {
  return AsyncStorage.getItem(DIETARY_RESTRICTIONS_STORAGE_KEY);
}

export function setMachinePersistedState(context: ContextFrom<typeof dietaryRestrictionsModel>) {
  const jsonContext = JSON.stringify(context.restrictions);

  void AsyncStorage.setItem(DIETARY_RESTRICTIONS_STORAGE_KEY, jsonContext);
}
